module.exports = __webpack_public_path__ + "static/media/homework-completion-screen-footer.629b2000.png";